import { connect } from "react-redux";

import { checkPermissions } from "../checkPermissions";

const AccessControl = ({ children, renderNoAccess, userProfile, allow }) => {
  const permitted =
    userProfile.company &&
    checkPermissions(userProfile.company.currentSubscription, allow);

  if (permitted) {
    return children;
  }
  return renderNoAccess();
};

AccessControl.defaultProps = {
  isRoute: false,
  renderNoAccess: () => null
};

const mapStateToProps = ({ userProfile }) => {
  return {
    userProfile: userProfile.user
  };
};

const AccessControlConnected = connect(mapStateToProps)(AccessControl);

export { AccessControlConnected as AccessControl };
